import * as actions from "./actions";
import {
   initVideosDetails,
   getVideoById,
   videoToggleLike,
   videoPreReleaseForFree,
   videoToggleWatched,
}  from 'sites/api/MixApi';

import {
   fetchResourcesOperation,
}  from 'sites/state/modules/media-resources/operations';
import {
   getMediaCommentsOperation,
}  from 'sites/state/modules/media-comments/operations';
import { push } from 'connected-react-router';
import Router from 'sites/routes/router';
import { setSendModalState } from 'sites/state/modules/purchase-send/actions';
import toast from "common/utils/toast";
import { initMemberships } from 'sites/api/AuthApi';

export function fetchVideosOperation(param, emptyFilters) {
   return async dispatch => {
      dispatch(actions.fetchRequest());
      try {
         const { data }  = await initVideosDetails(param);
         await dispatch(fetchResourcesOperation('videos', 'video'))
         dispatch(actions.fetchRequestCompleted(data, !!emptyFilters))
         const prisingList = await initMemberships('upgrade=true')
         dispatch(actions.getPricingUpgradeList(prisingList))
      } catch (error) {
         dispatch(actions.fetchRequestFailed(error));
      }
   }
}
export function fetchVideosByFilterOperation(params) {
   return async dispatch => {
      dispatch(actions.fetchRequestByFilter());
      try {
         const { data }  = await initVideosDetails(params, true);
         dispatch(actions.fetchRequestByFilterCompleted(data))
      } catch (error) {
         dispatch(actions.fetchRequestByFilterFailed(error));
      }
   }
}
export function fetchNextVideosOperation(params) {
   return async dispatch => {
      dispatch(actions.fetchNextVideoRequest());
      try {
         const { data }  = await initVideosDetails(params);
         dispatch(actions.fetchNextVideoCompleted(data))
      } catch (error) {
         dispatch(actions.fetchNextVideoFailed(error));
      }
   }
}
export function toggleLikeOperation(id, videoType, isLike, successCallBack) {
   return async dispatch => {
      // dispatch(actions.toggleLikeRequest());
      try {
         let apiQuery = '';
         if(videoType) {
            apiQuery = `?video_type=${ videoType }`
         }
         await videoToggleLike(id, apiQuery);
         dispatch(actions.toggleLikeCompleted(id, isLike))
         if(successCallBack) successCallBack(id, isLike)
      } catch (error) {
         // dispatch(actions.toggleLikeFailed(error));
      }
   }
}

export function fetchVideoByIdOperation(id, videoType, callBack, isAuthUser, param = []) {
   return async dispatch => {
      dispatch(actions.fetchVideoByIdRequest());
      try {
         let apiQuery = '';
         if(videoType) {
            apiQuery = `?video_type=${ videoType }`
         }
         const { data }  = await getVideoById(id, apiQuery);
         if(!data.is_deleted){
            if(!!data.can_read_comments) {
               const commentsCount = data.comments_count;
               await dispatch(getMediaCommentsOperation(data.id, 'videos', commentsCount, param))
            }
            if(isAuthUser && !data.watched && !Boolean(data.is_available_pricings) && 'free' === data.stream_state) {
               await videoToggleWatched(id, apiQuery, { watched: true });
               dispatch(actions.toggleWatchedCompleted(id))
            }

         }

         dispatch(actions.fetchVideoByIdCompleted(data))
         if(callBack){
            callBack(data)
         }
      } catch (error) {
         const status = error?.response?.status;
         if(403 !== status && 401 !== status){
            let backRouteName = 'VIDEOS'
            if('livestream' === videoType){
               backRouteName = 'LIVE_STREAM_STUDIO'
            }
            dispatch(push({
               pathname: Router.route(backRouteName).getCompiledPath(),
            }))
         }
         dispatch(actions.fetchVideoByIdFailed(error));
      }
   }
}
export function preReleaseForFreeOperation(id, param = []) {
   return async dispatch => {
      dispatch(setSendModalState({ paymentButtonLoading: true }))
      try {
         const { data }  = await videoPreReleaseForFree(id);
         if(!!data.can_read_comments) {
            const commentsCount = data.comments_count;
            await dispatch(getMediaCommentsOperation(data.id, 'videos', commentsCount, param))
         }
         dispatch(actions.fetchVideoByIdCompleted(data))
         dispatch(setSendModalState({ paymentButtonLoading: false }))
      } catch (error) {
         if(error?.response?.data?.need_to_update) {
            toast.error(error.response.data.need_to_update[0])
            if(error.response.data.data) {
               const newData = error.response.data.data
               dispatch(actions.fetchVideoByIdCompleted(newData))
            }
         }
         dispatch(setSendModalState({ paymentButtonLoading: false }))
      }
   }
}

export function toggleWatchedOperation(id, videoType, data, successCallBack) {
   return async dispatch => {
      try {
         let apiQuery = '';
         if(videoType) {
            apiQuery = `?video_type=${ videoType }`
         }
         await videoToggleWatched(id, apiQuery, data);
         dispatch(actions.toggleWatchedCompleted(id))
         if(successCallBack) successCallBack()
      } catch (error) {

      }
   }
}

export function updateVideoDataAfterPurchaseOperation(data) {
   return async dispatch => {
      try {
         await videoToggleWatched(data.id, '', { watched: true });
         dispatch(actions.updateDataAfterPurchaseCompleted(data))
      } catch (error) {

      }
   }
}


export function getUpgradePricingListForAccess() {
   return async dispatch => {
      try {
         const { data } = await initMemberships('upgrade=true')
         await dispatch(actions.getPricingUpgradeList(data))
      } catch (error) {

      }
   }
}
